export class Flags {
  freeTrial: boolean;
  monthlyTrial: boolean;
  seasonal: boolean;
}
